module.exports = __webpack_public_path__ + "img/pc_march_of_the_penguins.18ab9a9e.png";